import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { ExtraMessageWithBlurredBg } from '@sorare/core/src/components/onboarding/ExtraMessageWithBlurredBg';
import { HighlightOverlay } from '@sorare/core/src/components/onboarding/HighlightOverlay';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { useCurrentSport } from '@sorare/core/src/hooks/useCurrentSport';
import useLifecycle, { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { useOnboardingHighlights } from '@sorare/core/src/hooks/useOnboardingHighlights';

export const BenchCardOnboarding = () => {
  const sport = useCurrentSport();
  const [step, setStep] = useState(0);
  const isTabletAndAbove = useIsTabletAndAbove();
  const onboardingHighlights = useOnboardingHighlights();
  const { lifecycle, update: updateLifecycle } = useLifecycle();

  if (
    sport !== Sport.NBA ||
    !onboardingHighlights ||
    lifecycle?.sawComposeTeamHighlights
  ) {
    return null;
  }

  if (step === 0) {
    return (
      <HighlightOverlay
        key="ComposeTeamAverageScore"
        highlightNames={['ComposeTeamAverageScore']}
        onClose={() => setStep(1)}
        extras={[
          {
            nextTo: 'ComposeTeamAverageScore',
            render: props => (
              <ExtraMessageWithBlurredBg
                align="center"
                anchor="bottom"
                positionProps={props}
                fullWidth={!isTabletAndAbove}
              >
                <LabelL>
                  <FormattedMessage
                    id="BenchCard.AverageScore.FTUE"
                    defaultMessage="Each player has an L10 score - the average fantasy points scored in their last 10 games"
                  />
                </LabelL>
              </ExtraMessageWithBlurredBg>
            ),
          },
        ]}
      />
    );
  }

  return (
    <HighlightOverlay
      highlightNames={['ComposeTeamRemainingPoints']}
      onClose={async () =>
        updateLifecycle(LIFECYCLE.sawComposeTeamHighlights, true)
      }
      extras={[
        {
          nextTo: 'ComposeTeamRemainingPoints',
          render: props => (
            <ExtraMessageWithBlurredBg
              align="start"
              anchor="top"
              positionProps={props}
              fullWidth={!isTabletAndAbove}
            >
              <LabelL>
                <FormattedMessage
                  id="BenchCard.RemainingPoints.FTUE"
                  defaultMessage="Their L10 count against the Points Cap. Keep your lineup within the cap!"
                />
              </LabelL>
            </ExtraMessageWithBlurredBg>
          ),
        },
      ]}
    />
  );
};
